import { getLatitude, getLongitude } from './locationAttachmentGetters';
export const buildLocationAttachmentUrl = locationAttachment => {
  const latitude = getLatitude(locationAttachment);
  const longitude = getLongitude(locationAttachment);
  const googleMapsLink = `https://maps.google.com/?q=${latitude},${longitude}`;
  return googleMapsLink;
};